import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import Componentes from '../../../components/user/componentes/listar';


function ListComponentesScreen () {
    return (
        <Fragment>
            <Head titulo="Listagem de Componentes | Departamento de TI" />
            <Header />
            <Componentes />
            <Footer />
        </Fragment>
    );
}

export default ListComponentesScreen;